class declareInventoryQueryCtrl {
    constructor($rootScope, $scope, httpRequest) {}
}

declareInventoryQueryCtrl.$inject = ['$rootScope', '$scope', 'httpRequest']
export default declareInventoryQueryCtrl



// WEBPACK FOOTER //
// ./src/app/outputManage/stock/InventoryQuery/declareInventoryQueryCtrl.js